import { getGroupData } from "apis/getGroupData";
import { updatePublicUser } from "apis/profileData";
import classNames from "classnames";
import { BundledTaskDropdown } from "components/BundledTaskDropdown/BundledTaskDropdown";
import { ChatPane } from "components/ChatPane/ChatPane";
import { ConditionalLink } from "components/conditionalLink";
import DashboardContainer from "components/dashboard/DashboardContainer";
import { AnimatedSlide } from "components/design/AnimatedSlide";
import Breadcrumb from "components/DesignSystem/Breadcrumb/Breadcrumb";
import { Button } from "components/DesignSystem/Button/Button";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import Modal from "components/DesignSystem/Modal/Modal";
import { ResizablePanel } from "components/DesignSystem/ResizablePanel/ResizablePanel";
import { Tag } from "components/DesignSystem/Tag/Tag";
import { GetFilteredStatusSection } from "components/home/TaxComponents/FilingCard";
import { FilingPendingItemsModal } from "components/home/TaxComponents/TasksOverview/FilingPendingItemsModal";
import { ArrowRight } from "components/icons/ArrowRight";
import { CalendarWithClockIcon } from "components/icons/CalendarWithClockIcon";
import { Seperator } from "components/icons/Chat/Seperator";
import { Cross } from "components/icons/Cross";
import { EnvelopeIcon } from "components/icons/EnvelopeIcon";
import { SmallRightArrow } from "components/icons/SmallRightArrow";
import TaskDetailArchive from "components/icons/TaskDetailArchive";
import TaskDetailUnarchive from "components/icons/TaskDetailUnarchive";
import { SideChatControl } from "components/SideChatControl/SideChatControl";
import { StateRegistrationIntakePanel } from "components/StateRegistrations/StateRegistrationIntakePanel";
import {
  AmendmentStatusLabel,
  TaskStateDropdownTag,
} from "components/tasks/taskForForeignCA/ForeignCATask";
import { TaskPriceLedger } from "components/tasks/taskPriceLedger/TaskPriceLedger";
import { ACTIVITY_TAB, CHAT_TAB, TAB_PARAM } from "constants/chatTab";
import {
  STAGE_KEY_COMPLETED,
  STAGE_KEY_DRAFT_SHARED,
  STAGE_KEY_MISSING_INFORMATION,
  STAGE_KEY_READY_TO_FILE,
} from "constants/clientProgressStageKeys";
import { DISPLAY_DATE } from "constants/date";
import { ARCHIVED, TASK_ARCHIVED, TASK_UNARCHIVED } from "constants/task";
import dayjs from "dayjs";
import { TASK_STATE_TO_COLOR } from "dictionaries";
import { useAnalytics } from "hooks/useAnalytics";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useLocalStorage } from "hooks/useLocalStorage";
import { useModal } from "hooks/useModal";
import { usePageTitle } from "hooks/usePageTitle";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useToast } from "hooks/useToast";
import { useContext, useEffect, useRef, useState } from "react";
import ReactCountryFlag from "react-country-flag";
import { useInView } from "react-intersection-observer";
import { useDispatch } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useGetTaskQuery } from "store/apis/task";
import { setDefaultChannel, setEntityAndTaskId } from "store/slices/chat";
import {
  collapseDashboardSidebar,
  setIsSidebarExpandable,
} from "store/slices/dashboard";
import { setShowPricingModal } from "store/slices/task";
import { setShowTaskReviewStep } from "store/slices/TaskReview";
import { STATE_FRANCHISE_TAX_DELAWARE } from "types/Models/services";
import {
  buildClientProgressStepDetails,
  getClientStageLabel,
} from "utils/clientProgress";
import { formatDate } from "utils/formatDate";
import { openLink } from "utils/openLink";
import { updateTaskArchival } from "../../apis/getTaskData";
import authContext from "../../jwt_context&axios/authContext";
import "../../static/styles/components/taxPage.css";
import ToolTip from "../design/toolTip";
import Loader from "../DesignSystem/Loader/loader";
import { DFTRequestDataModal } from "./DFTRequestDataModal";
import { Deadline } from "./editDeadline";
import GetIndex from "./getIndex";
import { useIsGroupV2Platform } from "hooks/useIsGroupV2Platform";
import { useIsSmallScreen } from "hooks/useIsSmallScreen";
import { useWindowSize } from "hooks/useWindowSize";
import { MobileTaskPageHeader } from "./MobileTaskPageHeader";
import { AmendmentTag } from "components/Task/AmendmentTag/AmendmentTag";

const DeadlineInfo = ({ task, authtoken, setModalShow, deadline }) => {
  let curDate = new Date();
  let deadlineDate = new Date(`${deadline}T09:00:00.000-07:00`);
  const remainingDays = Math.floor(
    (deadlineDate - curDate) / (24 * 60 * 60 * 1000)
  );

  return (
    <>
      {formatDate(task?.deadline)}
      {authtoken.is_service_user && setModalShow && (
        <>
          &nbsp;&nbsp;&nbsp;
          <i
            className="fas fa-pen penDeadline"
            aria-hidden={true}
            onClick={() => setModalShow(true)}
          />
        </>
      )}
      <br />
      {remainingDays === 0 ? "Today: " : ""}
      {remainingDays < 0 ? remainingDays * -1 : remainingDays} &nbsp;days
      {remainingDays < 0 ? " overdue " : " left "}
    </>
  );
};

export default function TaxPage({
  isFromServices = false,
  parentRoute = "",
  addEntityInUrl = false,
  onClose,
}) {
  const { alertToast, successToast } = useToast();
  const [channelId, setChannelId] = useState();
  const { localData, setItem: updateSideChatState } = useLocalStorage(
    "taskSideChat",
    true
  );
  const history = useHistory();
  const { search } = useLocation();
  const tabParam = new URLSearchParams(search).get(TAB_PARAM);
  const forceSideChat = tabParam === CHAT_TAB || tabParam === ACTIVITY_TAB;

  const clearTabParam = () => {
    const params = new URLSearchParams(search);
    params.delete(TAB_PARAM);
    history.replace({ search: params.toString() });
  };

  const setTabParam = (tab) => {
    const params = new URLSearchParams(search);
    params.set(TAB_PARAM, tab);
    history.replace({ search: params.toString() });
  };

  // On small screens chat starts closed and isn't persisted, so the saved
  // desktop preference doesn't open it over the form.
  const isSmallScreen = useIsSmallScreen();
  const { isMobile } = useWindowSize();
  const [isMobileChatOpen, setIsMobileChatOpen] = useState(false);
  const isChatPreferenceOpen = isSmallScreen ? isMobileChatOpen : localData;
  const setChatPreference = isSmallScreen
    ? setIsMobileChatOpen
    : updateSideChatState;

  const sideChat = {
    shown: forceSideChat || isChatPreferenceOpen,
    toggle: () => {
      const isOpen = forceSideChat || isChatPreferenceOpen;
      if (isOpen) clearTabParam();
      setChatPreference(!isOpen);
    },
    show: () => setChatPreference(true),
    hide: () => {
      clearTabParam();
      setChatPreference(false);
    },
  };

  const { isCustomer, isAdmin, isPersonalTaxUser } = useRoleBasedView();
  const { dispatch: dispatchCurrentGroup } = useCurrentGroupContext();

  const { taskId } = useParams();
  const { authtoken, updateUser: updateAuthUser } = useContext(authContext);
  const { trackEvent } = useAnalytics();
  const isGroupV2Platform = useIsGroupV2Platform();

  const {
    data: task,
    isLoading,
    refetch,
    isSuccess,
    isError,
    error,
  } = useGetTaskQuery({ taskId });
  const [modalShow, setModalShow] = useState(false);
  usePageTitle(`${task?.title || "Filing"}`);
  const [load, setLoad] = useState(true);
  const [showArchive, setShowArchive] = useState(false);
  const [currentUuid, setCurrentUuid] = useState(
    !Boolean(task?.state?.uuid) ? task?.task_states?.[0].uuid : task?.state.uuid
  );
  const [taskStepName, setTaskStepName] = useState("");
  const dispatch = useDispatch();
  const taskChannel = task?.channel?.channel_url;
  const parentRef = useRef(null);
  const { inView: taskDetailBarInView } = useInView({
    threshold: 0,
  });
  const showTaskReviewStep = task?.state?.show_review_modal;
  const taskStateType = task?.is_archived
    ? ARCHIVED
    : task?.state?.type || "Not Started";
  const requestDataModal = useModal();
  const pendingItemsModal = useModal();
  const isMissingInformation =
    task?.client_progress?.current_key === STAGE_KEY_MISSING_INFORMATION;
  const isEtdHidden =
    task?.client_progress?.current_key === STAGE_KEY_READY_TO_FILE ||
    task?.client_progress?.current_key === STAGE_KEY_COMPLETED ||
    task?.client_progress?.current_key === STAGE_KEY_DRAFT_SHARED;
  const hasStageDropdown =
    (task?.client_progress?.current_key !== STAGE_KEY_COMPLETED &&
      Boolean(task?.client_progress)) ||
    Boolean(task?.books_global_status);

  const handleEtdButtonClick = () => {
    if (isMissingInformation) {
      pendingItemsModal.open();
      return;
    }

    setTabParam(ACTIVITY_TAB);
  };

  useEffect(() => {
    dispatch(setShowTaskReviewStep(showTaskReviewStep));
  }, [dispatch, showTaskReviewStep]);

  useEffect(() => {
    dispatch(setIsSidebarExpandable(false));
    dispatch(collapseDashboardSidebar());
    return () => dispatch(setIsSidebarExpandable(true));
  }, []);

  useEffect(() => {
    const updateUser = async () => {
      try {
        const res = await updatePublicUser({
          isPublicUser: false,
        });
        updateAuthUser(res.data.data);
      } catch (e) {
        alertToast({ message: error?.response?.data?.error?.message });
      }
    };
    if (authtoken.is_public_user && !isLoading && isSuccess) {
      updateUser();
    }
  }, [authtoken.is_public_user, isLoading, isSuccess]);

  useEffect(() => {
    if (!isLoading) {
      dispatch(setDefaultChannel(taskChannel));
      dispatch(
        setEntityAndTaskId({
          channelTaskId: task?.uuid,
          channelEntity: task?.entity,
        })
      );
    }
  }, [dispatch, taskChannel]);

  useEffect(() => {
    if ((isSuccess, task)) {
      trackEvent("TASK_OPENED", {
        task_id: task.uuid,
        task_name: task.title,
        screen: `${task?.title || "Task"}`,
        comapny_group: task.group_name,
        task_type: task.template_type,
      });
    }

    if (isError) {
      trackEvent("TASK_OPEN_FAILED", {
        task_id: taskId,
        error_message: error?.data?.error?.message,
      });
    }
  }, [
    error?.data?.error?.message,
    isError,
    isSuccess,
    task,
    taskId,
    trackEvent,
  ]);

  useEffect(() => {
    refetch();
  }, [load]);

  const isArchived = task?.is_archived;
  const inkleDocId = task?.documents_group_id;

  const groupName = task?.group_name;
  const groupId = task?.group_uuid;
  const entityId = task?.entity?.uuid;

  useEffect(() => {
    if (!isCustomer && groupId) {
      getGroupData({ group_id: groupId }).then((response) => {
        if (response.status === 200) {
          dispatchCurrentGroup({
            type: "SET_GROUP",
            payload: response.data.data,
          });
        }
      });
    }
  }, [groupId]);

  useEffect(() => {
    if (task?.channel?.channel_url) {
      setChannelId(task.channel.channel_url);
    }
  }, [task?.channel?.channel_url]);

  const selectedState = !Boolean(task?.state?.uuid)
    ? task?.task_states?.[0].uuid
    : task?.state.uuid;

  const mainId = !Boolean(task?.state?.uuid)
    ? task?.task_states?.[0].uuid
    : task?.state.uuid;

  const isBundledTask = task?.bundled_tasks?.length > 0;

  const updateAssignee = async () => {
    await refetch().unwrap();
  };

  const updateFormFile = async () => {
    await refetch().unwrap();
  };

  const root = document.documentElement;
  root.addEventListener("mousemove", (e) => {
    root.style.setProperty("--posX", e.clientX + 10 + "px");
    root.style.setProperty("--posY", e.clientY + 10 + "px");
  });

  const handleArchive = async () => {
    try {
      const {
        data: {
          data: { is_archived },
        },
      } = await updateTaskArchival({ taskId });
      successToast({ message: is_archived ? TASK_ARCHIVED : TASK_UNARCHIVED });
      setShowArchive(false);
      refetch().unwrap();
    } catch (e) {
      setShowArchive(false);
      alertToast({ message: error?.response?.data?.error?.message });
    }
  };

  let breadcrumbItem = isAdmin ? `/crm/${groupId}/new-filings` : "/tax/filings";
  if (isFromServices) {
    breadcrumbItem = parentRoute;
  }
  if (addEntityInUrl) {
    breadcrumbItem += `?entity=${entityId}`;
  }
  let breadcrumbTitle = isFromServices ? "Services" : "Filings";
  const isDftTask = task?.base_task_key === STATE_FRANCHISE_TAX_DELAWARE;

  const entityBasePath = isAdmin
    ? `/admin/crm/${groupId}/entity/${entityId}`
    : `/tax/entities/entity/${entityId}`;

  const entityLink = isGroupV2Platform
    ? `${entityBasePath}/profile`
    : entityBasePath;

  const entityFlag = task?.entity && (
    <ToolTip text={task.entity.name}>
      <ConditionalLink to={entityLink}>
        <div className="t-flex t-items-center t-gap-1">
          <ReactCountryFlag
            countryCode={task.entity.code_alpha_2}
            svg
            title={task.entity.country}
            style={{
              width: "1.25em",
              height: "1.25em",
            }}
            className="t-rounded"
          />
        </div>
      </ConditionalLink>
    </ToolTip>
  );

  const statusSection = task && (
    <>
      {!isCustomer && hasStageDropdown && (
        <span className="t-ml-2 ">
          <TaskStateDropdownTag task={task} />
        </span>
      )}
      {!isCustomer && !hasStageDropdown && (
        <Dropdown.Root>
          <Dropdown.Trigger
            asChild
            disabled={!isAdmin}
            className={classNames({
              "!t-cursor-default": !isAdmin,
            })}
          >
            <span className="t-ml-2">
              <Tag
                tagType={TASK_STATE_TO_COLOR[taskStateType]}
                icon={false}
                size="small"
              >
                <AmendmentStatusLabel
                  label={taskStepName || task.state?.name || "Not started"}
                  amendmentNumber={task.client_progress?.amendment_number}
                />
                {isAdmin && (
                  <div className="t-rotate-90 t-group-data-state-open:-t-rotate-90">
                    <ArrowRight stroke="1.5" color="currentColor" />
                  </div>
                )}
              </Tag>
            </span>
          </Dropdown.Trigger>
          <Dropdown.Portal>
            <Dropdown.Content>
              {task.task_states
                ?.filter(({ name }) => name !== "Pricing")
                .map(({ uuid, name, type, order }) => (
                  <Dropdown.Item
                    key={uuid}
                    onSelect={() => {
                      setCurrentUuid(uuid);
                      setTaskStepName(name);
                    }}
                    disabled={order > task.state?.order}
                  >
                    {name}
                  </Dropdown.Item>
                ))}
            </Dropdown.Content>
          </Dropdown.Portal>
        </Dropdown.Root>
      )}
      {isCustomer && task.client_progress?.completed_states?.length > 0 && (
        <div className="t-ml-2 t-flex t-items-center t-gap-1.5">
          <GetFilteredStatusSection
            status={getClientStageLabel({
              key: task.client_progress.current_key,
              label: task.client_progress.current_label,
              paymentStatus: task.payment_status,
            })}
            stepDetails={buildClientProgressStepDetails(
              task.client_progress,
              task.payment_status
            )}
            isActionPending={false}
            showProgress
            latestEtd={task.estimated_time_of_delivery?.date ?? null}
            taskUuid={task.uuid ?? null}
            previousCycles={task.client_progress.previous_cycles}
          />
          {(isMissingInformation ||
            (task.estimated_time_of_delivery?.date && !isEtdHidden)) && (
            <>
              <Seperator />
              <ToolTip
                propClass="t-w-72"
                text={
                  isMissingInformation ? (
                    <div className="t-space-y-1.5 t-text-left">
                      <div className="t-text-body-sm t-text-white">
                        We&apos;ll update the estimated draft date once we
                        receive the required information from you.
                      </div>
                      <Button
                        type="button"
                        customType="link"
                        size="small"
                        onClick={pendingItemsModal.open}
                      >
                        <span className="t-flex t-items-center t-gap-1 t-text-purple-40">
                          View pending items
                          <SmallRightArrow />
                        </span>
                      </Button>
                    </div>
                  ) : (
                    <div className="t-space-y-0.5">
                      <div className="t-text-body-sm t-text-white t-text-left">
                        Draft expected by this date.
                        <br />
                        Click to view all updates.
                      </div>
                    </div>
                  )
                }
              >
                <Button
                  size="small"
                  customType="ghost"
                  onClick={handleEtdButtonClick}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  <span className="t-text-text-30 hover:t-text-text-60 t-flex t-gap-1 t-items-center">
                    <CalendarWithClockIcon />
                    <span
                      className={classNames("t-text-body-sm", {
                        "t-italic": isMissingInformation,
                      })}
                    >
                      {isMissingInformation
                        ? "Pending on you"
                        : dayjs(task.estimated_time_of_delivery.date).format(
                            DISPLAY_DATE
                          )}
                    </span>
                  </span>
                </Button>
              </ToolTip>
            </>
          )}
          {isMissingInformation && task.uuid && (
            <FilingPendingItemsModal
              open={pendingItemsModal.isOpen}
              onOpenChange={pendingItemsModal.close}
              taskUuid={task.uuid}
              filingName={task.title}
            />
          )}
        </div>
      )}
      {isCustomer && task.client_progress?.amendment_number > 0 && (
        <span className="t-ml-2">
          <AmendmentTag
            amendmentNumber={task.client_progress.amendment_number}
          />
        </span>
      )}
    </>
  );

  const chatControl = (
    <SideChatControl
      channelId={channelId ? channelId : task?.channel?.channel_url}
      open={sideChat.shown}
      onOpenChange={sideChat.toggle}
    />
  );

  const mobileMenuItems = task
    ? [
        isAdmin &&
          isDftTask && {
            key: "request-data",
            label: "Request data confirmation",
            icon: <EnvelopeIcon />,
            onSelect: requestDataModal.open,
          },
        !isCustomer && {
          key: "archive",
          label: isArchived ? "Unarchive" : "Archive",
          icon: isArchived ? (
            <TaskDetailUnarchive color="currentColor" />
          ) : (
            <TaskDetailArchive color="currentColor" />
          ),
          onSelect: () => setShowArchive(true),
        },
        {
          key: "view-details",
          label: "View details",
          onSelect: () => dispatch(setShowPricingModal(true)),
        },
      ].filter(Boolean)
    : [];

  const bundledDropdown = isBundledTask && (
    <BundledTaskDropdown
      tasks={(task?.bundled_tasks ?? []).map(({ name, state, uuid, type }) => ({
        uuid,
        name,
        link: `/tax/filings/${uuid}`,
        stateLabel: state,
        tagType: TASK_STATE_TO_COLOR[type || "Not Started"] || "gray",
      }))}
    />
  );

  const mobileHeaderMeta = [
    { key: "bundled", node: isMobile && bundledDropdown },
    { key: "entity", node: !isPersonalTaxUser && entityFlag },
    { key: "status", node: statusSection },
    {
      key: "archived",
      node: isArchived && (
        <div className="t-rounded t-bg-neutral-10 t-px-2 t-py-1 t-text-body-sm">
          Archived
        </div>
      ),
    },
  ];

  if (isLoading) {
    return (
      <div className="t-w-full">
        <Loader />
      </div>
    );
  }

  return (
    <DashboardContainer className="t-h-full">
      {isSmallScreen && task && (
        <MobileTaskPageHeader
          title={task.title}
          onBack={onClose}
          titleSuffix={!isMobile && bundledDropdown}
          metaItems={mobileHeaderMeta}
          menuItems={mobileMenuItems}
          chatControl={chatControl}
        />
      )}
      <div
        className={classNames(
          "t-flex t-items-center t-justify-between t-gap-2 t-text-text-100 t-px-5 t-py-3",
          { "t-hidden": isSmallScreen && task }
        )}
      >
        <div className="t-self-end">
          <Breadcrumb.Root>
            <Breadcrumb.Item link={breadcrumbItem}>
              {breadcrumbTitle}
            </Breadcrumb.Item>
          </Breadcrumb.Root>
        </div>
        <Button customType="icon" size="xsmall" onClick={onClose}>
          <span className="t-text-text-100">
            <Cross color="currentColor" />
          </span>
        </Button>
      </div>
      <div className="t-flex t-flex-1 t-min-h-0">
        <DashboardContainer className="t-h-full t-min-w-0 t-flex-1">
          <DashboardContainer.Header
            className={classNames(
              "t-px-5 t-pb-3 t-border t-border-solid t-border-neutral-10 t-border-t-0 t-border-l-0 t-border-r-0",
              { "t-hidden": isSmallScreen }
            )}
          >
            {task && (
              <div
                className={classNames(
                  "t-flex t-h-8 t-w-full t-flex-col t-items-stretch"
                )}
              >
                <div className="t-flex t-flex-col t-justify-between">
                  <Deadline
                    deadline={task?.deadline}
                    modalShow={modalShow}
                    setModalShow={setModalShow}
                  />
                  <div className="leftHeadBack md:t-flex-wrap-none t-flex-col t-flex-wrap t-justify-between md:t-flex-row">
                    <div className="md:t-flex-wrap-none t-flex t-flex-wrap t-self-start md:t-self-center t-items-center">
                      <span className="t-text-subtitle">{task?.title}</span>
                      {isBundledTask && (
                        <BundledTaskDropdown
                          triggerClassName="t-ml-2"
                          tasks={(task.bundled_tasks ?? []).map(
                            ({ name, state, uuid, type }) => ({
                              uuid,
                              name,
                              link: `/tax/filings/${uuid}`,
                              stateLabel: state,
                              tagType:
                                TASK_STATE_TO_COLOR[type || "Not Started"] ||
                                "gray",
                            })
                          )}
                        />
                      )}
                      {authtoken.is_service_user && (
                        <>
                          <div className="me-2 t-mx-2 t-font-medium t-text-neutral-10">
                            {" "}
                            |
                          </div>
                          <div className="t-flex t-gap-4 t-text-body t-text-neutral">
                            <span
                              className={classNames(
                                "!t-text-body !t-font-medium t-text-text-60",
                                {
                                  groupName: task?.has_group_perm,
                                }
                              )}
                              onClick={() =>
                                task?.has_group_perm &&
                                openLink(`/crm/${groupId}`, "_blank")
                              }
                            >
                              {groupName}
                            </span>
                          </div>
                        </>
                      )}
                      <div className="me-2 t-ml-2 t-font-medium t-text-neutral-10">
                        {" "}
                        |
                      </div>
                      {!isPersonalTaxUser && (
                        <span className="t-flex t-items-center">
                          {entityFlag}
                          <div className="t-ml-2 t-font-medium t-text-neutral-10">
                            {" "}
                            |
                          </div>
                        </span>
                      )}
                      {statusSection}
                      {isArchived && (
                        <>
                          <div className="me-2 t-mx-2 t-font-medium t-text-neutral-10">
                            {" "}
                            |
                          </div>
                          <div className="t-rounded t-bg-neutral-10 t-px-2 t-py-1 t-text-body-sm">
                            <div>Archived</div>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="t-flex t-gap-2 t-items-center sm:t-self-baseline">
                      {isAdmin && isDftTask && (
                        <ToolTip
                          text={
                            <div className="t-space-y-1">
                              <div className="t-text-body-sm t-text-white">
                                Request data confirmation
                              </div>
                              {task.email_log && (
                                <>
                                  <div className="t-text-body-sm t-text-neutral-30">
                                    Last sent:{" "}
                                    {formatDate(task.email_log.sent_at)}
                                  </div>
                                  <div className="t-text-body-sm t-text-neutral-30">
                                    Number of times sent: {task.email_log.count}
                                  </div>
                                </>
                              )}
                            </div>
                          }
                        >
                          <Button
                            customType="icon"
                            size="small"
                            onClick={requestDataModal.open}
                          >
                            <div className="t-text-text-60">
                              <EnvelopeIcon />
                            </div>
                          </Button>
                        </ToolTip>
                      )}
                      {!isCustomer && (
                        <div className="t-cursor-pointer">
                          <ToolTip text={isArchived ? "Unarchive" : "Archive"}>
                            <span>
                              <Button
                                customType="icon"
                                size="small"
                                onClick={() => setShowArchive(true)}
                              >
                                <div className="archiveBox t-text-text-30">
                                  {isArchived ? (
                                    <TaskDetailUnarchive color="currentColor" />
                                  ) : (
                                    <TaskDetailArchive color="currentColor" />
                                  )}
                                </div>
                              </Button>
                            </span>
                          </ToolTip>
                        </div>
                      )}
                      <div className="t-w-max">
                        <Button
                          size="small"
                          onClick={() => dispatch(setShowPricingModal(true))}
                          block
                        >
                          View details
                        </Button>
                      </div>
                      {!sideChat.shown && (
                        <div className="t-flex t-items-center t-gap-2">
                          <div className="t-bg-neutral-20 t-h-5 t-w-[1.5px]"></div>
                          {chatControl}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </DashboardContainer.Header>
          <DashboardContainer.Content className="t-overflow-hidden">
            <div className="t-flex sm:t-flex-col t-h-full">
              <div className="t-w-full t-h-full">
                {task && (
                  <div className="t-overflow-auto t-relative t-h-[calc(100%-56px)] t-flex t-flex-col">
                    {task?.state_registration_intake && (
                      <StateRegistrationIntakePanel
                        intakeData={task.state_registration_intake}
                      />
                    )}
                    <div
                      className={classNames(
                        "taxPage t-flex t-flex-col t-h-full",
                        {
                          "t-sticky t-top-0": !taskDetailBarInView,
                        }
                      )}
                    >
                      <div
                        className={classNames(
                          "t-w-full t-flex t-relative rightTax t-h-full",
                          {
                            cr: isLoading,
                          }
                        )}
                        ref={parentRef}
                      >
                        <GetIndex
                          updatedTaskFormFile={updateFormFile}
                          data={task?.task_states}
                          inkleDocId={inkleDocId}
                          currentStateStep={currentUuid || selectedState}
                          setCurrentStateStep={setCurrentUuid}
                          setTaskStepName={setTaskStepName}
                          selectedState={selectedState}
                          chk={task?.doc_data?.data}
                          form_data={task?.form_data}
                          groupName={groupName}
                          docId={task?.doc_data?.uuid}
                          description={task?.description}
                          pricingData={task?.subtitle}
                          pricingAmount={task?.payment_amount}
                          title={task?.title}
                          uid={task?.state}
                          mainId={mainId}
                          task={task}
                          setLoad={setLoad}
                          groupId={groupId}
                          isArchived={isArchived}
                          parentRef={parentRef}
                          updateAssignee={updateAssignee}
                          refetchTask={refetch}
                          isFromServices={isFromServices}
                          taskStateType={taskStateType}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {showArchive && (
                <Modal.Root open={showArchive} onOpenChange={setShowArchive}>
                  <Modal.Content size="small">
                    <Modal.Header>
                      <Modal.Title>
                        {isArchived
                          ? "Unarchive this filing?"
                          : "Archive this filing?"}
                      </Modal.Title>
                      <Modal.Close />
                    </Modal.Header>
                    <Modal.Body>
                      Are you sure you want to archive this filing?
                    </Modal.Body>
                    <Modal.FooterButtonGroup>
                      <Button onClick={() => setShowArchive(false)}>
                        Cancel
                      </Button>
                      <Button customType="danger" onClick={handleArchive}>
                        {isArchived ? "Unarchive" : "Archive"}
                      </Button>
                    </Modal.FooterButtonGroup>
                  </Modal.Content>
                </Modal.Root>
              )}
              {requestDataModal.isOpen && (
                <DFTRequestDataModal {...requestDataModal} task={task} />
              )}
            </div>
          </DashboardContainer.Content>
        </DashboardContainer>

        {isSmallScreen && sideChat.shown && (
          <div className="t-fixed t-inset-0 t-z-modal t-flex t-flex-col t-bg-surface">
            <ChatPane
              channelId={channelId}
              setChannelId={setChannelId}
              headerWithOnlySwitch
              hidable
              hideControl={sideChat}
            />
          </div>
        )}

        <AnimatedSlide
          isVisible={sideChat.shown && !isSmallScreen}
          direction="right"
          className="t-max-w-max t-shrink-0 t-sticky"
        >
          <ResizablePanel
            defaultSize={360}
            minSize={280}
            maxSize={600}
            handleDirection="left"
            resetOnOpen={sideChat.shown}
            onCollapse={sideChat.hide}
            className="taskChat t-h-full t-border-solid t-border t-border-neutral-10 t-overflow-auto"
          >
            {sideChat.shown && !isSmallScreen && (
              <ChatPane
                channelId={channelId}
                setChannelId={setChannelId}
                headerWithOnlySwitch
                hidable
                hideControl={sideChat}
              />
            )}
          </ResizablePanel>
        </AnimatedSlide>
      </div>
    </DashboardContainer>
  );
}
